import React from "react";
import Header from "./Header";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa6";

export default function Customers() {
  return (
    <section className="min-h-[618px] lg:min-h-[815px] pt-5 lg:bg-circle lg:bg-no-repeat lg:bg-right-top mb-[100px]">
      <div className="container mx-auto">
        <Header />
      </div>

      <div className="mt-28 lg:mt-48 container text-left px-[7%] lg:ml-10">
        <h2
          data-aos="fade-down"
          data-aos-duration="800"
          className="text-4xl text-orange font-bold"
        >
          Look what our customers say
        </h2>
        <p
          data-aos="fade-down"
          data-aos-duration="1000"
          className="mt-14 text-lg text-gray-700"
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
          facilisi. Curabitur in libero neque. Integer et augue nec mi elementum
          convallis. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          Nulla facilisi. Curabitur in libero neque. Integer et augue nec mi
          elementum convallis. Lorem ipsum dolor sit amet, consectetur
          adipiscing elit.
        </p>
      </div>

      <div
        data-aos="fade-up"
        data-aos-duration="1200"
        className="mt-20 px-[8%] flex flex-col lg:flex-row gap-y-10 lg:gap-y-0 gap-x-14"
      >
        <div className="">
          <figure className="bg-white rounded shadow-lg overflow-hidden rotate-0 hover:rotate-1 transition duration-200">
            <blockquote className="p-8">
              <div className="mb-5 text-2xl text-orange">
                <FaQuoteLeft />
              </div>

              <p className="font-bold text-lg">
                Nulla facilisi. Curabitur in libero neque. Integer et augue nec
                mi elementum convallis. Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. Nulla facilisi.
              </p>

              <div className=" text-2xl w-full items-end text-orange ml-[90%]">
                <FaQuoteRight />
              </div>
            </blockquote>
            <div className="flex items-center justify-between px-8 py-4 bg-orange-200">
              <div className="flex items-center gap-5 rounded-full">
                <div className="rounded-full border-4 w-14 h-14 border-white">
                  <img
                    className="rounded-full"
                    src="https://avatars.githubusercontent.com/u/98827445?v=4"
                    alt="profile"
                  />
                </div>
                <figcaption className="text-white font-semibold">
                  <div>Lavanya Doohan</div>
                  <div className="opacity-70">Front-End Developer</div>
                </figcaption>
              </div>
            </div>
          </figure>
        </div>

        <div className="">
          <figure className="bg-white rounded shadow-lg overflow-hidden rotate-0 hover:rotate-1 transition duration-200">
            <blockquote className="p-8">


              <iframe
                width="460"
                height="215"
                src="https://www.youtube.com/embed/6qFCs20tWx4?si=C2SS8c3pCpxQF6oa&amp;start=459"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>

            </blockquote>
            <div className="flex items-center justify-between px-8 py-4 bg-pink-200">
              <div className="flex items-center gap-5 rounded-full">
                <div className="rounded-full border-4 w-14 h-14 border-white">
                  <img
                    className="rounded-full"
                    src="https://avatars.githubusercontent.com/u/98827445?v=4"
                    alt="profile"
                  />
                </div>
                <figcaption className="text-white font-semibold">
                  <div>Lavanya Doohan</div>
                  <div className="opacity-70">Front-End Developer</div>
                </figcaption>
              </div>
            </div>
          </figure>
        </div>
      </div>

      <div
        data-aos="fade-up"
        data-aos-duration="1200"
        className="mt-20 px-[8%] flex flex-col lg:flex-row gap-y-10 lg:gap-y-0 gap-x-14"
      >
        <div className="">
          <figure className="bg-white rounded shadow-lg overflow-hidden rotate-0 hover:rotate-1 transition duration-200">
            <blockquote className="p-8">

              <iframe
                width="460"
                height="215"
                src="https://www.youtube.com/embed/6qFCs20tWx4?si=C2SS8c3pCpxQF6oa&amp;start=459"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>

            </blockquote>
            <div className="flex items-center justify-between px-8 py-4 bg-pink-200">
              <div className="flex items-center gap-5 rounded-full">
                <div className="rounded-full border-4 w-14 h-14 border-white">
                  <img
                    className="rounded-full"
                    src="https://avatars.githubusercontent.com/u/98827445?v=4"
                    alt="profile"
                  />
                </div>
                <figcaption className="text-white font-semibold">
                  <div>Lavanya Doohan</div>
                  <div className="opacity-70">Front-End Developer</div>
                </figcaption>
              </div>
            </div>
          </figure>
        </div>

        <div className="">
          <figure className="bg-white rounded shadow-lg overflow-hidden rotate-0 hover:rotate-1 transition duration-200">
            <blockquote className="p-8">
              <div className="mb-5 text-2xl text-orange">
                <FaQuoteLeft />
              </div>

              <p className="font-bold text-lg">
                Nulla facilisi. Curabitur in libero neque. Integer et augue nec
                mi elementum convallis. Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. Nulla facilisi.
              </p>

              <div className=" text-2xl w-full items-end text-orange ml-[90%]">
                <FaQuoteRight />
              </div>
            </blockquote>
            <div className="flex items-center justify-between px-8 py-4 bg-orange-200">
              <div className="flex items-center gap-5 rounded-full">
                <div className="rounded-full border-4 w-14 h-14 border-white">
                  <img
                    className="rounded-full"
                    src="https://avatars.githubusercontent.com/u/98827445?v=4"
                    alt="profile"
                  />
                </div>
                <figcaption className="text-white font-semibold">
                  <div>Lavanya Doohan</div>
                  <div className="opacity-70">Front-End Developer</div>
                </figcaption>
              </div>
            </div>
          </figure>
        </div>
      </div>
    </section>
  );
}
